module.exports = __webpack_public_path__ + "static/media/7.0a224d90.gif";